// assets
import { Archive } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

const Batches: NavItemType = {
  id: 'group-batches',
  title: 'Batches',
  type: 'group',
  visibleForUserTypes: ['assessorAdmin'],
  children: [
    {
      id: 'batches',
      title: 'Batches',
      type: 'item',
      url: '/batches',
      icon: Archive,
      breadcrumbs: false
    }
  ]
};

export default Batches;
